import React, { useEffect, useState } from "react";
import { Button, CustomStepper } from "InnoUI/components";
import SC from "./style";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import theme from "theme";
import { useSearchParams } from "react-router-dom";
import MessageContent from "./MessageContent";
import NotificationContent from "./NotificationContent";
import axios from "axios";
import { readFromLocalStorage, showAlert } from "utils/helper";
import CustomBreadcrumb from "components/CustomBreadcrumb";
import AlarmContent from "./AlarmContent";

const BulkJournal = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const projectId = searchParams.get("projectId");
  const editing = searchParams.get("editing");
  const [activeStep, setActiveStep] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const authData = useSelector((state) => state?.authdata?.data || []);

  const [data, setData] = useState({
    content: {
      subject: "",
      message: `
   <p><br></p><p>Regards,</p><p><span style="color: rgb(255, 153, 0);">${authData?.fullName}</span></p>
  `,
      files: [],
    },
    occupants: {},
    alarm: {
      primaryalarm: {
        active: 1,
        alarmType: 0,
        alarmTo: authData.email,
      },
      secondaryalarm: {
        active: 0,
        alarmType: 1,
      },
    },
    selectList: "",
  });

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );

  const steps = [
    {
      heading: "Journal Content",
      description: "Insert Journal Subject & Content",
    },
    { heading: "Notification", description: "Send Journal Notification" },
    { heading: "Alarm", description: "Primary Alarm & Secondary Pre-alarm" },
  ];

  // handlenext button
  const handleNext = () => {
    if (!data.content?.subject) {
      setErrorMessage("Subject is required");
      return;
    }

    let active = data?.alarm?.primaryalarm?.active,
      alarmTo = data?.alarm?.primaryalarm?.alarmTo,
      alarmTime = data?.alarm?.primaryalarm?.alarmTime,
      alarmDate = data?.alarm?.primaryalarm?.alarmDate;

    if (
      activeStep == 2 &&
      ((active == 1 && !alarmDate) ||
        (active == 1 && !alarmTo) ||
        (active == 1 && !alarmTime))
    ) {
      showAlert({
        title: "Warning",
        text: "Primary Alarm details are required",
        icon: "warning",
      });
      return;
    }

    let sactive = data?.alarm?.secondaryalarm?.active,
      salarmTo = data?.alarm?.secondaryalarm?.alarmTo,
      salarmTime = data?.alarm?.secondaryalarm?.alarmTime,
      salarmDate = data?.alarm?.secondaryalarm?.alarmDate,
      smessage = data?.alarm?.secondaryalarm?.message;

    if (
      (sactive == 1 && !salarmDate) ||
      (sactive == 1 && !salarmTo) ||
      (sactive == 1 && !salarmTime) ||
      (sactive == 1 && !smessage)
    ) {
      showAlert({
        title: "Warning",
        text: "Secondary Alarm details are required",
        icon: "warning",
      });
      return;
    }
    if (
      (activeStep == 1) &
      (!data.occupants || Object.keys(data.occupants).length === 0)
    ) {
      showAlert({
        title: "Warning",
        text: "Please select a User",
        icon: "warning",
      });
      return;
    }

    setErrorMessage("");
    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    }
  };

  // handleBack
  const handleBack = () => {
    let active = data?.alarm?.primaryalarm?.active,
      alarmTo = data?.alarm?.primaryalarm?.alarmTo,
      alarmTime = data?.alarm?.primaryalarm?.alarmTime,
      alarmDate = data?.alarm?.primaryalarm?.alarmDate;

    if (active === 1 && (!alarmDate || !alarmTo || !alarmTime)) {
      // Set active to 0 if required fields are not filled
      setData((prevData) => ({
        ...prevData,
        alarm: {
          primaryalarm: {
            ...prevData.primaryalarm,
            active: 0,
          },
        },
      }));
    }
    // Similarly, handle secondary alarm validation
    let sactive = data?.alarm?.secondaryalarm?.active,
      salarmTo = data?.alarm?.secondaryalarm?.alarmTo,
      salarmTime = data?.alarm?.secondaryalarm?.alarmTime,
      salarmDate = data?.alarm?.secondaryalarm?.alarmDate,
      smessage = data?.alarm?.secondaryalarm?.message;

    if (
      sactive === 1 &&
      (!salarmDate || !salarmTo || !salarmTime || !smessage)
    ) {
      // Set secondary alarm active to 0 if required fields are not filled
      setData((prevData) => ({
        ...prevData,
        alarm: {
          secondaryalarm: {
            ...prevData.secondaryalarm,
            active: 0,
          },
        },
      }));
    }
    // Move to the previous step if applicable
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const {
    REACT_APP_BASE_URL: baseURL,
    REACT_APP_REQUEST_TIMEOUT: timeout,
    REACT_APP_API_KEY,
  } = process.env;

  let accessToken = REACT_APP_API_KEY;
  let userAuth = readFromLocalStorage("userAccessToken");
  let BASE_URL = baseURL || `${window.location.origin}/api`;
  userAuth = userAuth === null ? "" : userAuth;

  // handleSubmit
  const handleSubmit = async (e) => {
    e.preventDefault();

    let active = data?.alarm?.primaryalarm?.active,
      alarmTo = data?.alarm?.primaryalarm?.alarmTo,
      alarmTime = data?.alarm?.primaryalarm?.alarmTime,
      alarmDate = data?.alarm?.primaryalarm?.alarmDate;

    if (
      activeStep == 2 &&
      ((active == 1 && !alarmDate) ||
        (active == 1 && !alarmTo) ||
        (active == 1 && !alarmTime))
    ) {
      showAlert({
        title: "Warning",
        text: "Primary Alarm details are required",
        icon: "warning",
      });
      return;
    }

    let sactive = data?.alarm?.secondaryalarm?.active,
      salarmTo = data?.alarm?.secondaryalarm?.alarmTo,
      salarmTime = data?.alarm?.secondaryalarm?.alarmTime,
      salarmDate = data?.alarm?.secondaryalarm?.alarmDate,
      smessage = data?.alarm?.secondaryalarm?.message;

    if (
      (sactive == 1 && !salarmDate) ||
      (sactive == 1 && !salarmTo) ||
      (sactive == 1 && !salarmTime) ||
      (sactive == 1 && !smessage)
    ) {
      showAlert({
        title: "Warning",
        text: "Secondary Alarm details are required",
        icon: "warning",
      });
      return;
    }

    const payload = { ...data };
    // Create a FormData object
    const formData = new FormData();

    // Append scalar fields
    formData.append("inputData", JSON.stringify(payload) || "");

    // Append files array
    if (payload.content.files && payload.content.files.length > 0) {
      payload.content.files.forEach((file, index) => {
        formData.append(`files`, file);
      });
    }
    try {
      setLoading(true);
      let endpoint = `/v1/bulkjournal/addbulkjournal`;
      const url = BASE_URL + endpoint;
      const requestTimeout = timeout ? parseInt(timeout, 10) * 1000 : 180000;

      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          api_key: accessToken,
          Authorization: `Bearer ${userAuth}`,
        },
        timeout: requestTimeout,
      });
      setLoading(false);
      showAlert({
        title: "Success",
        text: response?.data?.message || "File updated successfully.",
        icon: "success",
      });
      if (payload.requestType == 1 || payload.requestType == 2) {
        navigate(-1);
      } else {
        navigate(-1);
      }
    } catch (error) {
      console.error("Error making API call:", error);
      showAlert({
        title: "Error",
        text: error?.response?.data?.message || "An unexpected error occurred.",
        icon: "error",
      });
      setLoading(false);
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <>
        <CustomBreadcrumb />

      <SC.NameContainer>
        <SC.ArrowC>
          <SC.ArrowBackIcon onClick={() => handleBackClick()} />
          <SC.Name>{"Bulk Journal"}</SC.Name>
        </SC.ArrowC>
      </SC.NameContainer>

      <SC.CustomStepperContainer>
        <CustomStepper
          steps={steps}
          handleNext={handleNext}
          handleBack={handleBack}
          activeStep={activeStep}
        />
      </SC.CustomStepperContainer>

      <SC.CardContainerStyle>
        {activeStep === 0 && (
          <MessageContent
            setData={setData}
            data={data}
            errorMessage={errorMessage}
          />
        )}

        {activeStep === 1 && (
          <NotificationContent setData={setData} data={data} />
        )}
        {activeStep === 2 && <AlarmContent setData={setData} data={data} />}

        <SC.ButtonContaiiner>
          {activeStep == 0 && (
            <Button
              caption="Cancel"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
              onClick={handleBackClick}
            />
          )}

          {activeStep > 0 && (
            <Button
              caption="Back"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
              disabled={activeStep === 0 || loading}
              onClick={handleBack}
            />
          )}

          {activeStep < steps.length - 1 && (
            <Button
              caption={"Next"}
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
              disabled={activeStep === steps.length - 1}
              onClick={handleNext}
            />
          )}
          {activeStep === steps.length - 1 && (
            <Button
              caption={loading ? "Submitting..." : "Submit"}
              type="submit"
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
              onClick={handleSubmit}
              disabled={loading}
            />
          )}
        </SC.ButtonContaiiner>
      </SC.CardContainerStyle>
    </>
  );
};

export default BulkJournal;
